// Parser not related to any domain like flights or hotels
import { isValid, parse } from "date-fns";
import { DATE_FORMAT } from "../../constants/hotelConstants";

export const parseDateFromQueryParam = (date: any): Date | undefined => {
  const hasValidType = typeof date === "string" || date instanceof Date;
  if (!date || !hasValidType) return undefined;
  const dateInDateFormat = typeof date === "string" ? parse(date, DATE_FORMAT, new Date()) : date;
  return isValid(dateInDateFormat) ? dateInDateFormat : undefined;
};